var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 6.20993C6.18738 6.39618 6.44084 6.50072 6.70502 6.50072C6.96921 6.50072 7.22266 6.39618 7.41002 6.20993L11 2.57993V23C11 23.2652 11.1054 23.5195 11.2929 23.7071C11.4805 23.8946 11.7348 24 12 24C12.2652 24 12.5196 23.8946 12.7071 23.7071C12.8947 23.5195 13 23.2652 13 23V2.58993L16.62 6.20993C16.713 6.30366 16.8236 6.37805 16.9454 6.42882C17.0673 6.47959 17.198 6.50573 17.33 6.50573C17.462 6.50573 17.5927 6.47959 17.7146 6.42882C17.8365 6.37805 17.9471 6.30366 18.04 6.20993C18.2263 6.02257 18.3308 5.76912 18.3308 5.50493C18.3308 5.24074 18.2263 4.98729 18.04 4.79993L14.13 0.879925C13.5675 0.318122 12.805 0.00256348 12.01 0.00256348C11.215 0.00256348 10.4525 0.318122 9.89002 0.879925L6.00002 4.79993C5.81377 4.98729 5.70923 5.24074 5.70923 5.50493C5.70923 5.76912 5.81377 6.02257 6.00002 6.20993Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.7189692dcef69e4a17cd893ed6a5f2cd.svg";
export { ForwardRef as ReactComponent };